import { useCallback, useEffect, useMemo, useState } from 'react';
import { AssetReviewItem, getProjectAssetReviews } from '../../../api';

export function useProjectAssetReviews(projectId: string | undefined, enabled: boolean) {
  const [projectAssetReviews, setProjectAssetReviews] = useState<AssetReviewItem[]>([]);

  const loadProjectReviews = useCallback(async () => {
    if (!projectId || !enabled) return;
    try {
      const { reviews } = await getProjectAssetReviews(projectId);
      setProjectAssetReviews(reviews || []);
    } catch {
      // Non-critical data; keep the current review state on failure.
    }
  }, [projectId, enabled]);

  useEffect(() => {
    loadProjectReviews();
  }, [loadProjectReviews]);

  const reviewStatusMap = useMemo(() => {
    const map = new Map<string, string>();
    for (const review of projectAssetReviews) {
      const key = `${review.characterName}|${review.characterState}`;
      map.set(key, review.status);
    }
    return map;
  }, [projectAssetReviews]);

  return { loadProjectReviews, reviewStatusMap };
}
